import { Directive, ElementRef, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * HACK: this is an approach to add ElementRef.nativeElement to FormControl instances without using '@ViewChild()'
 * primary usage for 'app-form-error-summary-sheet.component'
 *
 * source: https://stackoverflow.com/questions/39642547/is-it-possible-to-get-native-element-for-formcontrol
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formControlName]'
})
export class FormControlElementRefDirective implements OnInit {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  constructor(private readonly ngControl: NgControl, private readonly el: ElementRef) {}

  ngOnInit() {
    const { ngControl, el } = this;
    (ngControl.control as any).nativeElement = el.nativeElement;
  }
}
